/**
 * Klijent za API platforme (operater NENASAL, `/v1/platform/*`). Sesija operatera je odvojena od
 * sesije firme: cookie `sm_psession` (HttpOnly) i `sm_pcsrf` (čitljiv iz JS-a), a mutacije šalju
 * `X-CSRF-Token` = `sm_pcsrf` (ne `sm_csrf`).
 */
import { createApiClient, readCookie, type ApiClient, type ApiClientError } from '@sm/api';
import { bcp47, isLangCode } from '@sm/i18n';

import { env } from '@/env';

import { APP_BUILD, APP_VERSION } from './observability';

export const PLATFORM_CSRF_COOKIE = 'sm_pcsrf';
export const PLATFORM_LOGIN_PATH = '/platforma/prijava';

type UnauthorizedHandler = (err: ApiClientError) => void;
let unauthorizedHandler: UnauthorizedHandler | null = null;

/** Router registruje handler (preusmjeravanje na /platforma/prijava) pri pokretanju. */
export function setPlatformUnauthorizedHandler(fn: UnauthorizedHandler | null): void {
  unauthorizedHandler = fn;
}

function currentLang(): string {
  try {
    const l = localStorage.getItem('sm-lang');
    return bcp47(isLangCode(l) ? l : 'sr');
  } catch {
    return 'sr-Latn';
  }
}

export const platformApi: ApiClient = createApiClient({
  baseUrl: env.apiUrl,
  credentials: 'include',
  getCsrfToken: () => readCookie(PLATFORM_CSRF_COOKIE),
  getLanguage: currentLang,
  clientInfo: { client: 'web', appVersion: APP_VERSION, appBuild: APP_BUILD },
  fetch: (input, init) => globalThis.fetch(input, init),
  onUnauthorized: (err) => {
    if (typeof window === 'undefined') return;
    // Prijava sama vraća 401 za pogrešnu lozinku: tu se ne preusmjerava.
    if (window.location.pathname.startsWith(PLATFORM_LOGIN_PATH)) return;
    unauthorizedHandler?.(err);
  },
});
